import { marketersCardTransactions } from '~/content/marketers';

/**
 * Dark red panel with the card's recent ad-spend transactions (Figma 1280:50057),
 * used as the image of "The nsave Card" FeatureBlock. Drawn on the 700px design
 * panel (630px on mobile, where the card sits larger) and scaled via `cqw`, so
 * 1em is one design pixel inside the card.
 */
export function MarketersCardPanel() {
  return (
    <div className="@container relative grid aspect-square w-full place-items-center overflow-hidden bg-red-900 lg:aspect-auto lg:h-[720px]">
      <div className="text-[length:calc(100cqw/630)] lg:text-[length:calc(100cqw/700)]">
        <div className="h-[432.06em] w-[492.43em] rounded-[49.68em] bg-white pt-[42.61em] ps-[48.9em]">
          <ul className="flex w-[389.44em] flex-col gap-[22.06em]">
            {marketersCardTransactions.map((tx) => (
              <li
                key={tx.merchant}
                className="flex items-center gap-[15.57em] border-black-6 not-first:border-t-[2.6em] not-first:pt-[22.06em]">
                <span className="grid size-[51.9em] shrink-0 place-items-center overflow-hidden rounded-full bg-white">
                  <img
                    src={tx.logo}
                    alt=""
                    loading="lazy"
                    style={{ width: `${tx.logoWidth}em`, height: `${tx.logoHeight}em` }}
                    className="max-w-none object-contain"
                  />
                </span>
                <span className="flex flex-1 items-center justify-between text-[20.76em] leading-[1.38] font-medium tracking-[0.004em] whitespace-nowrap text-grey-1000">
                  <span>{tx.merchant}</span>
                  <span>{tx.amount}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
